export default "__VITE_ASSET__CwikSZWW__"